import { useState } from "react";
import type { MockMessageMedia } from "@/dummy";

function prefersReducedMotion(): boolean {
  return (
    typeof window !== "undefined" &&
    !!window.matchMedia?.("(prefers-reduced-motion: reduce)").matches
  );
}

/**
 * A short looping clip rendered like a GIF: autoplay, loop, muted, inline, no controls. Under
 * `prefers-reduced-motion` it shows the poster and neither autoplays nor loops. If the source fails
 * the poster stays (no blank box). Fills the box reserved by `VideoTile`.
 */
export function GifVideo({ item }: { item: MockMessageMedia }) {
  const [failed, setFailed] = useState(false);
  const [still] = useState(prefersReducedMotion);
  const cls = "absolute inset-0 block h-full w-full object-cover";

  if (failed) {
    // biome-ignore lint/performance/noImgElement: fixed bundled poster, sized by the reserved box
    return item.poster ? <img src={item.poster} alt={item.alt} className={cls} /> : null;
  }
  return (
    <video
      src={item.url}
      poster={item.poster}
      aria-label={item.alt}
      autoPlay={!still}
      loop={!still}
      muted
      playsInline
      preload="metadata"
      onError={() => setFailed(true)}
      className={cls}
    />
  );
}
